import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Tag } from '../modal/tag';

export interface EditTagParams {
  fieldId: string;
  fieldName: string;
}

export const updateTagAPI = async ({ fieldId, fieldName }: EditTagParams) => {
  const resp = await baseAPI.patch<Tag>(`/tags/${fieldId}`, {
    fieldName,
  });
  return resp.data;
};

export const useUpdateTagMutation = () => {
  return useMutation({
    mutationFn: async (params: EditTagParams) => {
      const response = await updateTagAPI(params);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.TAGS,
      });
    },
  });
};
